/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type TempoSeverity = typeof TempoSeverity[keyof typeof TempoSeverity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TempoSeverity = {
  Green: 'Green',
  Yellow: 'Yellow',
  Red: 'Red',
} as const;
